module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.setRequest
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 48 + 52)
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: item.inn,
      on: {
        "click": function($event) {
          return _vm.select(item.inn)
        }
      }
    }, [_c('v-list-tile-content', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item, '_blank'))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatDescription(item))
      }
    })])])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642e47be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/HumanSelectorTab.vue
// module id = 901
// module chunks = 1